import { graphql } from "gql.tada";
import { LinkFragment } from "../fragments/LinkFragment";

export const NewsReelSectionById = graphql(
  `
    query NewsReelSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      newsReelSection(id: $id, preview: $preview, locale: $locale) {
        ...NewsReelSectionFragment
      }
    }

    fragment NewsReelSectionFragment on NewsReelSection {
      title
      description
      viewAllUrl
      readMore
      viewAll
      title
      viewAllUrl
      headline
      newsRealItemCollection(limit: 3) {
        items {
          image {
            url
            title
          }
          link {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [LinkFragment]
);
